import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const TooltipTrigger: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(16),
    color: theme.siteVariables.colors.charcoal[250],
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: pxToRem(431),
    lineHeight: theme.siteVariables.lineHeightLarge,
});

export const TooltipContent: StyleRule = () => ({
    textAlign: 'center',
    wordBreak: 'break-word',
});
